import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { toast } from 'sonner';
import { getStoreByOwner, updateStore } from '../lib/firebaseService';
import { FileText } from 'lucide-react';

export default function StoreAbout() {
  const { firebaseUser } = useAuth();
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (firebaseUser) {
      loadStore();
    }
  }, [firebaseUser]);

  const loadStore = async () => {
    try {
      setPageLoading(true);
      const userStore = await getStoreByOwner(firebaseUser.uid);
      if (userStore) {
        setStore(userStore);
        setDescription(userStore.description || '');
      }
    } catch (error) {
      console.error('Mağaza yüklənə bilmədi:', error);
    } finally {
      setPageLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!store) {
      toast.error('Əvvəlcə mağaza yaradın');
      return;
    }

    setLoading(true);
    try {
      await updateStore(store.id, { description });
      toast.success('Məlumat saxlanıldı');
      loadStore();
    } catch (error) {
      console.error('Xəta:', error);
      toast.error('Əməliyyat uğursuz oldu');
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-64">
          <p className="text-muted-foreground">Yüklənir...</p>
        </div>
      </DashboardLayout>
    );
  }

  if (!store) {
    return (
      <DashboardLayout>
        <div className="max-w-2xl">
          <div className="bg-white rounded-xl border border-border p-8 text-center">
            <p className="text-muted-foreground mb-4">Əvvəlcə mağaza yaradın</p>
            <Button onClick={() => window.location.href = '/dashboard/store/info'}>
              Mağaza Yarat
            </Button>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="max-w-3xl">
        <div className="mb-6">
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <FileText className="w-8 h-8" />
            Mağaza Haqqında
          </h1>
          <p className="text-muted-foreground mt-1">Mağazanız haqqında məlumat</p>
        </div>

        <div className="bg-white rounded-xl border border-border p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="description">Təsvir</Label>
              <p className="text-xs text-muted-foreground mb-2">
                Mağazanız, məhsullarınız və ya xidmətləriniz haqqında qısa məlumat yazın
              </p>
              <Textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={8}
                placeholder="Məsələn: Biz 2020-ci ildən bəri keyfiyyətli məhsullar təqdim edirik. Müştəri məmnuniyyəti bizim əsas prioritetimizdir..."
                className="resize-none"
              />
              <p className="text-xs text-muted-foreground mt-2">
                {description.length} simvol
              </p>
            </div>

            {description && (
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-sm mb-2">Önizləmə:</h3>
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{description}</p>
              </div>
            )}

            <div className="pt-4">
              <Button type="submit" className="w-full h-11" disabled={loading}>
                {loading ? 'Saxlanılır...' : 'Yadda Saxla'}
              </Button>
            </div>
          </form>
        </div>

        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            <strong>Məsləhət:</strong> Mağazanızı tanıdan, müştəriləri cəlb edən və etibar yaradan məlumat yazın.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}
